import {
  Control,
  FormState,
  UseFormGetValues,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form';
import {
  DirectoryRoles,
  isAbleToSeeUIElement,
} from '../../../../utils/roles/client-roles';
import AddressAccordion from '../../user-details/profile-information-old/address-accordion';
import EmailsAccordion from '../../user-details/profile-information-old/emails-accordion';
import GenderAccordion from '../../user-details/profile-information-old/gender-accordion';
import IdsAccordion from '../../user-details/profile-information-old/ids-accordion';
import ImsAccordion from '../../user-details/profile-information-old/ims-accordion';
import NotesAccordion from '../../user-details/profile-information-old/notes-accordion';
import OrganizationsAccordion from '../../user-details/profile-information-old/organizations-accordion';
import PhonesAccordion from '../../user-details/profile-information-old/phones-accordion';
import RelationsAccordion from '../../user-details/profile-information-old/relations-accordion';
import WebsitesAccordion from '../../user-details/profile-information-old/websites-accordion';
import { UserFormValues } from '../user-schema';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface StepProfileInformationProps {
  setValue: UseFormSetValue<UserFormValues>;
  getValues: UseFormGetValues<UserFormValues>;
  control: Control<UserFormValues>;
  formState: FormState<UserFormValues>;
  watch: UseFormWatch<UserFormValues>;
  directoryRoles: string[];
}

export default function StepProfileInformation({
  setValue,
  getValues,
  control,
  formState,
  watch,
  directoryRoles,
}: StepProfileInformationProps) {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="body2" sx={{ mb: 2 }}>
        Add additional information about the user by clicking the plus icon on
        the accordion sections below. You can add multiple items to each by
        clicking the plus icon again and reorder as needed.
      </Typography>
      <Box sx={{ p: 1 }}>
        <AddressAccordion
          control={control}
          errors={formState.errors}
          setValue={setValue}
          watch={watch}
          getValues={getValues}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditAddresses.value
            )
          }
        />
        <EmailsAccordion
          control={control}
          errors={formState.errors}
          watch={watch}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditEmailAddress.value
            )
          }
        />
        <GenderAccordion
          control={control}
          errors={formState.errors}
          watch={watch}
          user={null}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditGender.value
            )
          }
        />
        <IdsAccordion
          control={control}
          watch={watch}
          errors={formState.errors}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditExternalIds.value
            )
          }
        />
        <ImsAccordion
          control={control}
          watch={watch}
          errors={formState.errors}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditInstantMessaging.value
            )
          }
        />
        <NotesAccordion
          control={control}
          user={null}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditNotes.value
            )
          }
        />

        <OrganizationsAccordion
          control={control}
          watch={watch}
          errors={formState.errors}
          setValue={setValue}
          getValues={getValues}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditOrganizations.value
            )
          }
        />
        <PhonesAccordion
          control={control}
          watch={watch}
          errors={formState.errors}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditPhoneNumbers.value
            )
          }
        />
        <RelationsAccordion
          control={control}
          watch={watch}
          errors={formState.errors}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditRelationships.value
            )
          }
        />
        <WebsitesAccordion
          control={control}
          errors={formState.errors}
          watch={watch}
          disabled={
            !isAbleToSeeUIElement(
              directoryRoles,
              DirectoryRoles.EditWebsites.value
            )
          }
        />
      </Box>
    </Box>
  );
}
